import { render } from "./actions.vue?vue&type=template&id=50760fd5&ts=true"
import script from "./actions.vue?vue&type=script&lang=ts"
export * from "./actions.vue?vue&type=script&lang=ts"

import "./actions.vue?vue&type=style&index=0&id=50760fd5&lang=scss"

import exportComponent from "/tmp/build_c94111dd/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__